// WebGl definitions
page.three.init = function(){
    log.webgl("INIT");
    var wgl = page.three;
    wgl.canvas = document.getElementById("wglCanvas");
    if(wgl.canvas == undefined ) {
        log.webgl(`INIT: Canvas not found`, 1);
        return false;
    }
    wgl.scene = new THREE.Scene();
    wgl.camera = new THREE.PerspectiveCamera(75, window.innerWidth/window.innerHeight,0.1,10);
    wgl.renderer = new THREE.WebGLRenderer({canvas:wgl.canvas, antialias:true, alpha:false, powerPreference: "high-performance", precision: "highp"});
    wgl.renderer.setPixelRatio(window.devicePixelRatio>2?2:window.devicePixelRatio);
    //console.log(wgl.renderer.getPixelRatio());
    log.webgl(`INFO: Pixel Ratio: ${wgl.renderer.getPixelRatio()}`);
    wgl.renderer.setSize(window.innerWidth, window.innerHeight);
    wgl.loader = new THREE.TextureLoader();
    wgl.modelLoader = new THREE.GLTFLoader();

    var dracoLoader = new THREE.DRACOLoader();
    dracoLoader.setDecoderPath( 'https://www.gstatic.com/draco/versioned/decoders/1.5.6/' );
    wgl.modelLoader.setDRACOLoader( dracoLoader );


    wgl.composer = new THREE.EffectComposer(wgl.renderer);
    wgl.fxaaPass = new THREE.ShaderPass( THREE.FXAAShader );
    var pixelRatio = wgl.renderer.getPixelRatio();
    wgl.fxaaPass.material.uniforms[ 'resolution' ].value.x = 1 / ( window.innerWidth * pixelRatio );
    wgl.fxaaPass.material.uniforms[ 'resolution' ].value.y = 1 / ( window.innerHeight * pixelRatio );
    wgl.renderPass = new THREE.RenderPass(wgl.scene, wgl.camera);
    wgl.composer.addPass(wgl.renderPass);
    wgl.composer.addPass(wgl.fxaaPass);

    wgl.gLight = new THREE.AmbientLight(0xffffff, 1.0);
    wgl.scene.add(wgl.gLight);
    wgl.camera.position.z = 4;
    
    wgl.bgMat = new THREE.ShaderMaterial({
        uniforms: THREE.BgGradShader.uniforms,
        vertexShader: THREE.BgGradShader.vertexShader,
        fragmentShader: THREE.BgGradShader.fragmentShader,
        dithering: true
    });
    wgl.bgPlaneGeometry = new THREE.PlaneBufferGeometry(2,2);
    wgl.bgPlane = new THREE.Mesh(wgl.bgPlaneGeometry, wgl.bgMat);
    wgl.scene.add(wgl.bgPlane);

    wgl.texture.lapas.tex = wgl.loader.load(wgl.texture.lapas.path, function(){
        //wgl.preloader.elements.done += 1;
        //console.log("loaded");
        log.webgl("TEXTURE: Loaded (lapas)", 2);
        var mymat = new THREE.MeshBasicMaterial({
            color:0xffffff,
            transparent: false
        });
        //wgl.precGeo = new THREE.CylinderBufferGeometry(0.32, 0.3, 0.01, 24, 1,true, 0, 0);
        wgl.precGeo = new THREE.CylinderBufferGeometry(0.32, 0.3, 0.01, 24, 1,true, 0, 0);
        wgl.precMesh = new THREE.Mesh(wgl.precGeo, mymat);
        wgl.preMat = new THREE.MeshBasicMaterial({
            color:0xffffff,
            transparent: true,
            alphaMap: wgl.texture.lapas.tex
        });
        wgl.preGeo = new THREE.PlaneBufferGeometry(0.4,0.4,1,1);
        wgl.preMesh = new THREE.Mesh(wgl.preGeo, wgl.preMat);
        wgl.preMat.opacity = 0;
        wgl.precMesh.material.opacity = 0;
        wgl.scene.add(wgl.preMesh);
        wgl.scene.add(wgl.precMesh);
        
        wgl.precMesh.rotation.x = -Math.PI / 2;

        //page.control.preloader.show();
    });

    var sides = page.v.quality.loader;
    wgl.transMat = new THREE.ShaderMaterial(THREE.transShader);
    wgl.transGeo = new THREE.PlaneBufferGeometry( 1, 1, sides, sides );
    wgl.transition = new THREE.Points(wgl.transGeo, wgl.transMat);

    wgl.scene.add(wgl.transition);
    wgl.transition.renderOrder = 20;
    
    page.control.preloader.show();
    return true;
}

page.three.resize = function(){
    log.webgl("RESIZE");
    var wgl = page.three;
    var vh = window.innerHeight * 0.01;
    var w = window.innerWidth;
    var h = window.innerHeight;

    var sw = Math.round(w * page.v.quality.resolution);
    var sh = Math.round(h * page.v.quality.resolution);

    document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));
    //wgl.vars.ratio = window.innerWidth / window.innerHeight;
    wgl.camera.aspect = window.innerWidth / window.innerHeight;
    wgl.camera.updateProjectionMatrix();

    wgl.renderer.setSize( sw, sh );
    wgl.composer.setSize( sw, sh );
    var pixelRatio = wgl.renderer.getPixelRatio();
    wgl.fxaaPass.material.uniforms[ 'resolution' ].value.x = 1 / ( sw * pixelRatio );
    wgl.fxaaPass.material.uniforms[ 'resolution' ].value.y = 1 / ( sh * pixelRatio );
    $("#wglCanvas").css({
        "width":w+"px",
        "height":h+"px"
    });

    if(page.three.v.readyToShow && !page.three.v.alwaysRender){
        log.webgl("SINGLE RENDER");
        //page.three.calc();
        page.three.render();
    }
}

page.three.calc = function(){
    var wgl = page.three;
    wgl.f.bg.calc();
    wgl.f.preloader.calc();
    wgl.f.transition.calc();
    if(wgl.v.models.loaded){
        wgl.f.models.calc();
        page.control.models.update();
    }
}

page.three.render = function(){
    var wgl = page.three;
    var v = page.v;
    wgl.camera.position.x = THREE.Math.lerp(wgl.camera.position.x, Math.cos(-v.mouse.px*wgl.v.camRotation + 1.5708) * 4, wgl.v.camSpeed);
    wgl.camera.position.z = THREE.Math.lerp(wgl.camera.position.z, (Math.sin(v.mouse.px*wgl.v.camRotation + 1.5708) * Math.cos(v.mouse.py*wgl.v.camRotation)) * 4, wgl.v.camSpeed);
    wgl.camera.position.y = THREE.Math.lerp(wgl.camera.position.y, Math.sin(-v.mouse.py*wgl.v.camRotation) * 4, wgl.v.camSpeed);
    
    wgl.camera.lookAt(0,0,0);
    wgl.camera.updateProjectionMatrix();

    wgl.composer.render();
}